import { render } from "./ClientsTicker.vue?vue&type=template&id=c664b390&scoped=true"
const script = {}

import "./ClientsTicker.vue?vue&type=style&index=0&id=c664b390&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c664b390"]])

export default __exports__